import React from "react";
import {
  Box,
  Button,
  Container,
  Heading,
  HStack,
  Image,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { company, contact } from "../data/content";

export default function Hero() {
  return (
    <Box
      as="section"
      id="top"
      bg="ink.800"
      color="white"
      position="relative"
      overflow="hidden"
    >
      {/* Soft brand glow, purely decorative */}
      <Box
        position="absolute"
        top="-140px"
        right="-100px"
        w="420px"
        h="420px"
        bg="brand.500"
        opacity={0.14}
        filter="blur(90px)"
        borderRadius="full"
        pointerEvents="none"
      />
      <Container maxW="6xl" px={{ base: 5, md: 8 }} py={{ base: 16, md: 28 }}>
        <VStack spacing={7} textAlign="center" position="relative">
          <Image
            src={`${process.env.PUBLIC_URL}/company_logo.jpg`}
            alt={`${company.name} logo`}
            boxSize={{ base: "84px", md: "104px" }}
            borderRadius="full"
            objectFit="cover"
            border="2px solid"
            borderColor="whiteAlpha.400"
          />

          <VStack spacing={2}>
            <Heading as="h1" fontSize={{ base: "3xl", md: "5xl" }} maxW="4xl">
              {company.name}
            </Heading>
            <Text
              className="arabic"
              fontSize={{ base: "md", md: "lg" }}
              color="whiteAlpha.800"
              dir="rtl"
            >
              {company.legalNameAr}
            </Text>
          </VStack>

          <HStack spacing={3}>
            <Box w="24px" h="2px" bg="brand.500" />
            <Text
              fontSize={{ base: "sm", md: "md" }}
              fontWeight={600}
              letterSpacing="0.14em"
              textTransform="uppercase"
              color="brand.300"
            >
              {company.tagline}
            </Text>
            <Box w="24px" h="2px" bg="brand.500" />
          </HStack>

          <Text fontSize={{ base: "md", md: "lg" }} color="whiteAlpha.900" maxW="3xl">
            {company.intro}
          </Text>

          <Stack direction={{ base: "column", sm: "row" }} spacing={3} pt={2} w={{ base: "full", sm: "auto" }}>
            <Button as="a" href="#contact" variant="brand" size="lg">
              Request a Quote
            </Button>
            <Button
              as="a"
              href={contact.phoneHref}
              size="lg"
              variant="outline"
              color="white"
              borderColor="whiteAlpha.500"
              _hover={{ bg: "whiteAlpha.200" }}
            >
              Call {contact.phoneDisplay}
            </Button>
          </Stack>
        </VStack>
      </Container>
    </Box>
  );
}
